require('./lbLoadingPlaceholder.scss');

const $inject = [];

const lbLoadingPlaceholder = {
  template: require('./lbLoadingPlaceholder.html'),
  transclude: true,
};

lbLoadingPlaceholder.$inject = $inject;

export default lbLoadingPlaceholder;



// WEBPACK FOOTER //
// ./src/components/lbLoadingPlaceholder/lbLoadingPlaceholder.js